import { useState } from 'react'

import { EMPTY_LIST } from '../../../constants/common'

export function useFilePreviewGallery({ files = EMPTY_LIST }) {
  const [activeFileId, setActiveFileId] = useState(null)

  // Track the open file by id and derive its index, so the active preview
  // stays in sync with `files` — e.g. a file added/updated right after a
  // click resolves to the right index on the next render.
  const fileIndex = files?.findIndex(i => i.id === activeFileId) ?? -1

  const activeFileIndex =
    activeFileId != null && fileIndex >= 0 ? fileIndex : null

  function handleClickFile(fileId) {
    setActiveFileId(fileId)
  }

  function handleCloseFilePreview() {
    return setActiveFileId(null)
  }

  return {
    activeFileIndex,
    handleClickFile,
    handleCloseFilePreview,
  }
}
